import React, { useState, useRef, useCallback, useEffect, useMemo } from 'react';
import {
    GoogleMap,
    Autocomplete,
    Marker,
    useJsApiLoader
} from "@react-google-maps/api";
import { CgPen } from 'react-icons/cg';

const GeoLocationView = ({ subCatId, mapLocation, showEditIcon, setGeoLocationAddress }) => {
    const [map, setMap] = useState(null);
    const [markerPosition, setMarkerPosition] = useState(null);
    const [searchAddress, setSearchAddress] = useState("");
    const [autocomplete, setAutocomplete] = useState(null);
    const [formData, setFormData] = useState({ latitude: null, longitude: null });
    const inputRef = useRef(null);

    const defaultCenter = { lat: 30.3165, lng: 78.0322 }; // Fallback coordinates

    const GmapOptions = {
        disableDefaultUI: false,
        draggable: true,
        scrollwheel: true,
        streetViewControl: false,
    };

    const loaderOptions = useMemo(() => ({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyAvo944SiO688JPdwJcZd919QWQiBN7kW4',
        libraries: ["places"],
    }), []);

    const { isLoaded } = useJsApiLoader(loaderOptions);

    const geocodeAddress = useCallback((address) => {
        if (
            window.google &&
            window.google.maps &&
            typeof window.google.maps.Geocoder === "function" &&
            address
        ) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address }, (results, status) => {
                if (status === "OK" && results[0]) {
                    const location = results[0].geometry.location;
                    const latLng = { lat: location.lat(), lng: location.lng() };
                    setMarkerPosition(latLng);
                    // setGeoLocationAddress(address)
                    setSearchAddress(address);
                    setFormData({ latitude: latLng.lat, longitude: latLng.lng });
                    map?.setCenter(latLng);
                    map?.setZoom(15);
                } else {
                    setMarkerPosition(defaultCenter);
                    setFormData({
                        latitude: defaultCenter.lat,
                        longitude: defaultCenter.lng 
                    });
                    map?.setCenter(defaultCenter);
                    map?.setZoom(12);
                }
            });
        }
    }, [map]);

    useEffect(() => {
        if (isLoaded && mapLocation) {
            setSearchAddress(mapLocation);
            geocodeAddress(mapLocation);
        }
    }, [isLoaded, mapLocation, geocodeAddress]);

    useEffect(() => {
        setGeoLocationAddress(searchAddress);
    }, [searchAddress]);

    const onLoad = useCallback((mapInstance) => {
        setMap(mapInstance);
    }, []);

    const onPlaceChanged = () => {
        if (autocomplete) {
            const place = autocomplete.getPlace();
            if (place.geometry && place.geometry.location) {
                const location = place.geometry.location;
                const latLng = { lat: location.lat(), lng: location.lng() };
                setMarkerPosition(latLng);
                // setGeoLocationAddress(`${place.name} ${place.formatted_address}` || "")
                setSearchAddress(`${place.name} ${place.formatted_address}` || "");
                map?.panTo(latLng);
                map?.setZoom(15);
                setFormData({
                    latitude: latLng.lat,
                    longitude: latLng.lng 
                });
            }
        }
    };

    const onAutocompleteLoad = (autocompleteInstance) => {
        setAutocomplete(autocompleteInstance);
    };

    const onMarkerDragEnd = (e) => {
        const latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
        setMarkerPosition(latLng);
        setFormData({ latitude: latLng.lat, longitude: latLng.lng });

        if (
            window.google &&
            window.google.maps &&
            typeof window.google.maps.Geocoder === "function"
        ) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: latLng }, (results, status) => {
                if (status === "OK" && results[0]) {
                    setSearchAddress(results[0].formatted_address);
                }
            });
        }
    };

    if (!isLoaded) return <div>Loading...</div>;

    return (
        <>

            <div className="col-md-12 mt-2">
                    <div className="row">
                        <div className="mt-4">
                            <div className="form-block">
                                {!showEditIcon ? (
                                    <Autocomplete onLoad={onAutocompleteLoad} onPlaceChanged={onPlaceChanged}>
                                        <input
                                            type="text"
                                            ref={inputRef}
                                            placeholder="Search for an address"
                                            value={searchAddress}
                                            onChange={(e) => {
                                                setSearchAddress(e.target.value);
                                                setGeoLocationAddress(e.target.value);
                                            }}
                                            className="form-control"
                                        />
                                    </Autocomplete>
                                ) : (
                                    <p>{searchAddress}</p>
                                )}

                                <GoogleMap
                                    onLoad={onLoad}
                                    center={markerPosition || defaultCenter}
                                    zoom={15}
                                    mapContainerStyle={{ height: "400px", width: "100%" }}
                                    options={GmapOptions}
                                >
                                    {markerPosition && (
                                        <Marker
                                            position={markerPosition}
                                            draggable={!showEditIcon}
                                            onDragEnd={onMarkerDragEnd}
                                        />
                                    )}
                                </GoogleMap>
                            </div>
                        </div>
                    </div>
            </div>

        </>
    );
};

export default GeoLocationView;
